import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23111295"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualitychecksafe-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fujian" }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_areaSelect = _resolveComponent("areaSelect")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_responsibilityperson = _resolveComponent("responsibilityperson")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.submitform.title) = $event)),
            rules: [{ required: true, message: '巡检名称必填' }],
            required: "",
            label: "巡检名称",
            placeholder: "请填写巡检名称",
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_areaSelect, {
            title: _ctx.submitform.title,
            remark: _ctx.submitform.remark,
            resultid: _ctx.submitform.result,
            resultname: _ctx.resultname,
            "change-person-id": _ctx.submitform.changePersonId,
            "change-person-name": _ctx.changePersonName,
            "area-idscolumns": _ctx.areaIdscolumns,
            onAreaConfirm: _ctx.areaConfirm
          }, null, 8, ["title", "remark", "resultid", "resultname", "change-person-id", "change-person-name", "area-idscolumns", "onAreaConfirm"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.resultname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resultname) = $event)),
            rules: [{ required: true, message: '巡检结果必填' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "巡检结果",
            placeholder: "请选择类型",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resultPicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.resultPicker,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resultPicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                columns: _ctx.resultPickerscolumns,
                "show-toolbar": "",
                "value-key": "name",
                onConfirm: _ctx.resultPickersonConfirm,
                onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resultPicker = false))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        (_ctx.submitform.result === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_responsibilityperson, {
                onSelectPerson: _ctx.selectPerson,
                onSelectPersonName: _ctx.selectPersonName
              }, null, 8, ["onSelectPerson", "onSelectPersonName"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.remark,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.submitform.remark) = $event)),
            rows: "2",
            autosize: "",
            label: "备注",
            type: "textarea",
            maxlength: "50",
            placeholder: "请输入留言",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_field, {
            rules: [{ required: true, message: '请选择整改后照片' }],
            required: "",
            label: "附件"
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_uploader, {
                modelValue: _ctx.uploader,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploader) = $event)),
                "after-read": _ctx.afterRead,
                multiple: _ctx.$isIOS()
              }, null, 8, ["modelValue", "after-read", "multiple"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_button, {
            block: "",
            disabled: _ctx.flag,
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}